// @ts-nocheck TODO: type issues need to be fixed in this file
export const addSourceToURL = (URL, SOURCE) => `${URL}?source=${SOURCE}`;
